import Head from 'next/head'

export const RichSnippetsHome = () => {
  const baseUrl =
    process.env.NEXT_PUBLIC_URL_BASE || 'https://www.portalsolar.com.br'

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `{
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Portal Solar",
              "url": "${baseUrl}/",
              "logo": "${baseUrl}/assets/portalsolar.svg",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+55 11 4000-1948",
                "contactType": "customer service",
                "contactOption": "TollFree",
                "areaServed": "BR",
                "availableLanguage": "Portuguese"
              },
              "sameAs": [
                "https://www.facebook.com/PortalSolarBrasil",
                "https://www.instagram.com/portal_solar",
                "https://www.linkedin.com/company/portal-solar/",
                "https://www.youtube.com/channel/UCJ9aMiOTnwhRn2QV-DE_xiQ",
                "https://twitter.com/portalsolar_br"
              ]
            }`
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `{
            "@context": "https://schema.org",
            "@type": "WebSite",
            "url": "${baseUrl}/",
            "potentialAction": {
              "@type": "SearchAction",
              "target": {
                "@type": "EntryPoint",
                "urlTemplate": "${baseUrl}/noticias/resultado-pesquisa?q={search_term_string}"
              },
              "query-input": "required name=search_term_string"
            }
          }`
        }}
      />
    </Head>
  )
}
